import React, {FC, useState, FormEvent, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import Input from '../UI/Input';
import Button from '../UI/Button';
import Message from '../UI/Message';
import '../UI/fontawesome';
import {RootState} from '../../store';
import {setError} from '../../store/actions/authActions';
import {requestNarration} from '../../store/actions/articleActions';
import Player from '../../services/misc/plyrList';
import { PlaylistItem } from '../../store/constants/narrationConstants';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import playing from './sound.gif'



const FetchAudio: FC = () => {
    const [url, setURL] = useState('');
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const {error, token} = useSelector((state: RootState) => state.auth);
    const {narrated, request_url} = useSelector((state: RootState) => state.article);

    useEffect(() => {
        return () => {
            if (error) {
                dispatch(setError(''));
            }
        }
    }, [error, dispatch]);

    useEffect(() => {
        console.log("NARRATED");
    }, [narrated]);


    useEffect(() => {
        if (token) {
            (async () => {
                let api_url = "";
                if (window.location.hostname === 'localhost') {
                    const path = 'http://localhost:5001/nalij-api/us-central1/app/';
                    api_url = path + '/api/playlist';
                } else {
                    // production code
                    api_url = '/api/playlist';
                }
                const response = await fetch(api_url, {
                    method: 'get',
                    headers: new Headers({
                        'auth-token': token
                    })
                });

                //console.log("waiting on articles");
                setList( await response.json());
                //console.log("Articles arrived", articles);
                //setList(articles);
                const player = Player();
                player.on('playing', (event:any) => {
                    const plyr = event.detail.plyr;
                    console.log("Playing baby", plyr);
                  });
                  

            })();
        }

    }, [token, narrated, request_url]);

    const submitHandler = (e: FormEvent) => {
        e.preventDefault();
        if (error) {
            dispatch(setError(''));
        }
        //setLoading(true);
        dispatch(requestNarration(url, token));
    };


    return (

        <div className="player-page">
            <div className="plyr">
                <audio controls>
                </audio>
            </div>
            <div className="mx-2 my-4">
                <div className="container">
                    <div className="wrap-collabsible">
                        <input id="collapsible" className="toggle" type="checkbox"/>
                        <label htmlFor="collapsible" className="lbl-toggle is-size-6 collapsible">Request Audio
                            Narration</label>
                        <div className="collapsible-content">
                            <div className="content-inner">
                                <form className="form narration" onSubmit={submitHandler}>
                                    {error && <Message type="danger" msg={error}/>}
                                    <Input
                                        name="url"
                                        value={url}
                                        onChange={(e) => setURL(e.currentTarget.value)}
                                        placeholder="http://example.com/article-name.html"
                                        label=""
                                    />
                                    <span
                                        className="infoform has-text-centered is-size-7 mt-0 pt-0 has-text-weight-bold	">Enter the URL of the text article to be narrated. It currently has a 5000 character limit.</span>
                                    <Button text={loading ? "Narrating..." : "Get Audio"}
                                            className="is-primary is-fullwidth my-5" disabled={loading}/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="playlist">
            <ul className='playlist--loading'>
                    {list.filter((data: PlaylistItem)=>data.status !== "complete").map((data: PlaylistItem, index) => {
                             return <li className="loading" key={index} data-id={index} data-image="" data-audio={data.narration_url}  data-status={data.status}>
                            <span className="spinner">
                                <FontAwesomeIcon spin icon={['fas', 'circle-notch']} />
                            </span>
                            {data.title}
                            <span className="artist">{data.author}
                                <b> {data.source.replace('http://', '').replace('https://', '').replace('www.', '').split(/[/?#]/)[0]}</b></span>
                        </li>
                    })}

                </ul>
                <ul className='playlist--list'>
                    {list.filter((data: PlaylistItem)=>data.status === "complete").map((data: PlaylistItem, index) => {
                             return <li key={index} data-id={index} data-image="" data-audio={data.narration_url}  data-status={data.status} data-author={data.author}>
                                 <span className="playingimg">
                                    <img src={playing} alt="Logo" />
                                </span>
                                 {data.title}
                                <span className="artist">{data.author}
                                <b> {data.source.replace('http://', '').replace('https://', '').replace('www.', '').split(/[/?#]/)[0]}</b></span>    
                        </li>
                    })}
                </ul>
            </div>
        </div>
    );
};

export default FetchAudio;
